module.exports = "/_next/static/images/Hero2@2x-6574b019a64b316fccb41ff349dc4aef.png";